import { cn } from "@/lib/style"
import { getCdnUrl } from "@/config/cdn"

export interface CountryFlagBadgeProps {
  /** ISO 3166-1 alpha-2 country code (e.g., "US", "FR") */
  countryCode: string
  /** Size of the badge in pixels */
  size?: number
  /** Additional CSS classes */
  className?: string
}

export function CountryFlagBadge({
  countryCode,
  size = 24,
  className,
}: CountryFlagBadgeProps) {
  const code = countryCode.toUpperCase()
  const flagUrl = getCdnUrl(`images/flags/${code}.svg`)

  // Scale the flag larger than the badge to crop the edges
  const flagSize = Math.round(size * 1.1)

  return (
    <div
      className={cn(
        "inline-flex items-center justify-center rounded-full overflow-hidden",
        "bg-gray-100",
        className
      )}
      style={{ width: size, height: size }}
      title={code}
      aria-label={`Flag of ${code}`}
    >
      <img
        src={flagUrl}
        alt=""
        aria-hidden="true"
        className="object-cover"
        style={{ width: flagSize, height: flagSize }}
        draggable={false}
      />
    </div>
  )
}
